/* External dependencies */
import get from 'lodash/get';

/* Internal dependencies */
import { PaginationOptions } from '../types/Pagination';
import API from '.';
import { cleanObject } from 'src/common/cleanObject';
import { modelUser } from 'src/store/helpers/users';
import { ProfileType } from 'src/types/Profile';

export const listNotificationsForUser = async (userId: string, options: PaginationOptions & { profileId?: string; }) => {
  const limit = get(options, 'limit', 15);
  const offset = get(options, 'offset');
  let profileId = get(options, 'profileId');

  if (profileId) {
    profileId = `profile:${profileId}`;
  }

  const response = await API.get({
    path: `/users/${userId}/notifications`,
    options: {
      queryParams: cleanObject({
        limit,
        offset: offset && JSON.stringify(offset),
        profileId,
      }),
    },
  });

  response.items = response.items.map((notification: any) => ({
    ...notification,
    users: {
      ...notification.users,
      items: (notification.users.items || []).map((actor: ProfileType) => {
        const actorType = get(actor, 'type');

        if (actorType !== 'user') return actor;

        return modelUser(actor);
      }),
    },
  }));

  return response;
};